/* Lincoln James — Homepage JS
   Boot sequence, smooth scroll, reduced-motion guard. */
(function () {
  'use strict';

  var BOOT = [
    { text: 'LINCOLN_JAMES_OS v1.19.84',      delay: 100 },
    { text: 'INITIALIZING ARCHIVE SEARCH...', delay: 400 },
    { text: '1. THE VANISHING EIGHT',          delay: 300 },
    { text: '2. DEVILS LIKE US',               delay: 300 },
    { text: '3. ALL THE TIME',                 delay: 300 },
    { text: '4. WRITTEN JUST FOR YOU',         delay: 300 },
    { text: '5. WE ARE HUMAN',                 delay: 300 },
    { text: '6. THE NINTH LAYER',              delay: 300 },
    { text: 'LOADING... ALL WE WANTED',        delay: 800 },
    { text: '> SYSTEM READY.',                 delay: 500 },
    { text: '> WELCOME, READER.',              delay: 400 }
  ];

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function alreadySeen() {
    try { return !!sessionStorage.getItem('lj_boot_seen'); } catch (e) { return false; }
  }

  function markSeen() {
    try { sessionStorage.setItem('lj_boot_seen', '1'); } catch (e) {}
  }

  function revealPage() {
    var boot = document.getElementById('lj-boot');
    var main = document.getElementById('lj-main');
    if (!boot || !main) return;
    boot.style.transition = 'opacity 1.2s ease-out';
    boot.style.opacity = '0';
    setTimeout(function () {
      boot.style.display = 'none';
      main.style.opacity = '1';
    }, 1200);
  }

  function runBoot() {
    var terminal = document.getElementById('lj-terminal');
    if (!terminal) { revealPage(); return; }

    var total = 500;
    BOOT.forEach(function (line, idx) {
      setTimeout(function () {
        var p = document.createElement('p');
        p.textContent = line.text;
        p.style.opacity = '0';
        p.style.transition = 'opacity 0.2s ease-in';
        terminal.appendChild(p);
        requestAnimationFrame(function () { p.style.opacity = '0.85'; });
        terminal.scrollTop = terminal.scrollHeight;
        if (idx === BOOT.length - 1) {
          setTimeout(revealPage, 900);
        }
      }, total);
      total += line.delay;
    });
  }

  function initBoot() {
    var main = document.getElementById('lj-main');
    var boot = document.getElementById('lj-boot');
    if (!main || !boot) return;

    if (prefersReducedMotion() || alreadySeen()) {
      boot.style.display = 'none';
      main.style.opacity = '1';
      return;
    }
    markSeen();
    runBoot();
  }

  /* Smooth scroll for in-page anchors */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.querySelector(a.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
      });
    });
  }

  /* Intersection Observer scroll reveals */
  function initReveals() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.lj-reveal').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
    document.querySelectorAll('.lj-reveal').forEach(function (el) { obs.observe(el); });
  }

  function init() {
    initBoot();
    initSmoothScroll();
    initReveals();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
